import RegisterRanking from '@/pages/register/Ranking.vue';
import RegisterInfo from '@/pages/register/RegisterInfo.vue';
import ActivatedList from '@/pages/register/ActivatedList.vue';
import InactivatedList from '@/pages/register/InactivatedList.vue';
import ClosedList from '@/pages/register/ClosedList.vue';
import RegisterBlock from '@/pages/register/RegisterBlock.vue';
import SameRegister from '@/pages/register/SameRegister.vue';
import RegisterReport from '@/pages/register/RegisterReport.vue';

const register = {
	RegisterRanking: {
		title: '유저랭킹',
		heading: '유저랭킹',
		path: '/register/ranking',
		component: RegisterRanking,
	},
	RegisterInfo: {
		title: '회원 정보',
		heading: '회원 정보',
		path: '/register/register-info/:idRegister',
		component: RegisterInfo,
		type: 'v-app',
	},
	ActivatedList: {
		title: '회원 검색',
		heading: '회원 검색',
		path: '/register/activated-list',
		component: ActivatedList,
	},
	InactivatedList: {
		title: '휴면회원 리스트',
		heading: '휴면회원 리스트',
		path: '/register/inactivated-list',
		component: InactivatedList,
	},
	ClosedList: {
		title: '탈퇴회원 리스트',
		heading: '탈퇴회원 리스트',
		path: '/register/closed-list',
		component: ClosedList,
	},
	SameRegister: {
		title: '중복회원(기기)리스트',
		heading: '중복회원(기기)리스트',
		path: '/register/same-register',
		component: SameRegister,
	},
	RegisterBlock: {
		title: '회원차단 이력',
		heading: '회원차단 이력',
		path: '/register/register-block',
		component: RegisterBlock,
	},
	RegisterReport: {
		title: '회원신고 이력',
		heading: '회원신고 이력',
		path: '/register/register-report',
		component: RegisterReport,
	},
};

export default Object.entries(register).reduce((acc, [id, component]) => {
	acc[id] = {
		id,
		...component,
		options: {
			accessRight: {
				adminLevel: [2],
			},
		},
	};
	return acc;
}, {});
